/**
 * As zonas de um espaço enquanto uma aba, ou um espaço inteiro, é arrastado (docs/spec/room-layout.md):
 * perto de uma borda do conteúdo, o espaço se divide e o arrastado fica daquele lado. No miolo, as
 * abas se juntam às dele.
 */
import type { DropSide } from './layout.js';

export type Rect = { left: number; top: number; width: number; height: number };

/** Até que fração da largura (ou altura) a partir da borda o espaço se divide. */
export const SPLIT_EDGE = 0.3;

export function zoneIn(rect: Rect, x: number, y: number): DropSide | null {
  const fx = (x - rect.left) / Math.max(1, rect.width);
  const fy = (y - rect.top) / Math.max(1, rect.height);
  const distances: [DropSide, number][] = [
    ['left', fx],
    ['right', 1 - fx],
    ['top', fy],
    ['bottom', 1 - fy],
  ];
  const [side, distance] = distances.reduce((best, d) => (d[1] < best[1] ? d : best));
  return distance < SPLIT_EDGE ? side : null;
}

/** O pedaço do espaço que o destaque cobre: a metade do lado. */
export function zoneRect(rect: Rect, side: DropSide): Rect {
  const { left, top, width, height } = rect;
  if (side === 'left') return { left, top, width: width / 2, height };
  if (side === 'right') return { left: left + width / 2, top, width: width / 2, height };
  if (side === 'top') return { left, top, width, height: height / 2 };
  return { left, top: top + height / 2, width, height: height / 2 };
}
